import { useDotList } from "./useDotList";

export const hooks = {
  useDotList,
}
